<script lang="ts" setup>
import type { MetadataFragment } from '~/lib/graphql/graphql.ts'

const props = defineProps<{
  item: MetadataFragment
  include?: string[]
  exclude?: string[]
}>()

const client = useBoscaClient()
const document = await client.content.getDocument(props.item.id)
</script>

<template>
  <div class="font-serif">
    <template
      v-for="(node, index) in document.content"
      :key="index.toString()"
    >
      <ContentDocumentNode
        :item="item"
        :node="node"
        :include="include"
        :exclude="exclude"
      />
    </template>
  </div>
</template>
